const truthy = (value) => String(value || "").trim().toLowerCase() === "true";

export function buildHaloCampaign(env = process.env) {
  const paymentLink = String(env.REACT_APP_HALO_PAYMENT_LINK_URL || "").trim();

  return {
    campaign_stage: env.REACT_APP_HALO_CAMPAIGN_STAGE || "reservation",
    campaign_name: "Halo Traveller",
    campaign_subtitle: "Carry your own network.",
    reservation_product: "traveller",
    base_goal: 350000,
    amount_raised: null,
    kickstarter_prelaunch_url: env.REACT_APP_HALO_KICKSTARTER_PRELAUNCH_URL || "",
    kickstarter_live_url: env.REACT_APP_HALO_KICKSTARTER_LIVE_URL || "",
    late_pledge_url: env.REACT_APP_HALO_LATE_PLEDGE_URL || "",
    payment_link_url: paymentLink,
    reservations_enabled:
      truthy(env.REACT_APP_HALO_RESERVATIONS_ENABLED) && Boolean(paymentLink),
    reservation_amount: "A$10",
    campaign_launch_date: env.REACT_APP_HALO_CAMPAIGN_LAUNCH_DATE || "",
    founding_member_limit: null,
    enabled_regions: ["Australia", "New Zealand", "United States", "Canada", "United Kingdom", "European Union"],
    concept_asset_disclosure: "Concept design shown — final hardware and specifications may change.",
    certification_wording: "Pursuing ISO/IEC 27001 certification through an independent certification body and mapping LightningFlow controls to NIST CSF 2.0.",
    current_claim_ids: ["v9_0_1_baseline"],
  };
}

export const haloCampaign = buildHaloCampaign();

const stage = (campaign = haloCampaign) => campaign.campaign_stage;

export function campaignCta(campaign = haloCampaign) {
  if (stage(campaign) === "kickstarter_prelaunch") return "Follow Traveller on Kickstarter";
  if (stage(campaign) === "live") return "Back Halo Traveller";
  if (stage(campaign) === "late_pledge") return "Late pledge for Traveller";
  if (stage(campaign) === "fulfilment") return "Follow Traveller development";
  if (stage(campaign) === "reservation" && campaign.reservations_enabled) return `Reserve Halo Traveller for ${campaign.reservation_amount}`;
  return "Join the Traveller founding list";
}

export function campaignSecondaryCta(campaign = haloCampaign) {
  return stage(campaign) === "fulfilment" ? "Follow Traveller progress" : "See how Traveller works";
}

export function campaignDestination(campaign = haloCampaign) {
  if (stage(campaign) === "live") return campaign.kickstarter_live_url;
  if (stage(campaign) === "kickstarter_prelaunch") return campaign.kickstarter_prelaunch_url;
  if (stage(campaign) === "late_pledge") return campaign.late_pledge_url;
  return "";
}

export function reservationDestination(values = {}, campaign = haloCampaign) {
  if (!campaign.reservations_enabled || !campaign.payment_link_url) return "";
  let destination;
  try {
    destination = new URL(campaign.payment_link_url);
  } catch {
    return "";
  }
  if (
    destination.protocol !== "https:"
    || destination.hostname !== "buy.stripe.com"
    || destination.username
    || destination.password
  ) {
    return "";
  }
  const email = String(values.email || "").trim();
  const interest = String(campaign.reservation_product || "traveller").trim().toLowerCase();
  if (email) destination.searchParams.set("prefilled_email", email);
  if (interest) destination.searchParams.set("client_reference_id", `halo-${interest}`);
  return destination.toString();
}
